<template>
  <div class="questionnaire form-container">
    <form accept-charset="UTF-8"
          class="biosecurity-form"
          enctype="multipart/form-data"
          method="POST"
          onsubmit="return false">
      <div class="border-bottom mb-3"><!-- nav-scroller -->
        <div class="nav nav-tabs" role="tablist">
          <a class="nav-link active" data-toggle="tab" href="#bio-tab-one" role="tab">
            Sección I: GENERALES.
          </a>
          
          <a class="nav-link" data-toggle="tab" href="#bio-tab-two"
             role="tab">
            Sección II: DEL MATERIAL BIOLÓGICO.
          </a>
          
          <a class="nav-link" data-toggle="tab" href="#bio-tab-three"
             role="tab">
            Sección III: DEL MATERIAL CRETI.
          </a>
          
          <a class="nav-link" data-toggle="tab" href="#bio-tab-four"
             role="tab">
            Sección IV: RADIACTIVOS.
          </a>
          
          <a class="nav-link" data-toggle="tab" href="#bio-tab-five"
             role="tab">
            Sección V: ACREDITACIONES.
          </a>
        </div>
      </div>

      <div class="alert alert-info has-icon d-flex align-items-center"
           v-if="protocol.biosecurity_questionnaire_legacy && !protocol.biosecurity_questionnaire">
          <div class="alert-icon">
              <span class="oi oi-info"></span>
          </div>
          Este protocolo cuenta con un cuestionario de bioseguridad desactualizado.
          <a target="_blank"
              :href="`/committee/biosecurity/questionnaire/legacy/${protocol.id}/create`"
              class="alert-link ml-1">
            De clic aquí para visualizar las respuestas del formulario
          </a>
      </div>

      <div class="tab-content">
        <div id="bio-tab-one" class="tab-pane active" role="tabpanel">
          <section-one ref="section-one" :questionnaire="questionnaire"></section-one>
        </div>
        
        <div id="bio-tab-two" class="tab-pane" role="tabpanel">
          <section-two ref="section-two" :questionnaire="questionnaire"></section-two>
        </div>
        <div id="bio-tab-three" class="tab-pane" role="tabpanel">
          <section-three ref="section-three" :questionnaire="questionnaire"></section-three>
        </div>
        <div id="bio-tab-four" class="tab-pane" role="tabpanel">
          <section-four ref="section-four"
                        :protocol="protocol"
                        :questionnaire="questionnaire"></section-four>
        </div>
        <div id="bio-tab-five" class="tab-pane" role="tabpanel">
          <section-five ref="section-five"
                        :protocol="protocol"
                        :questionnaire="questionnaire"></section-five>
        </div>
      </div>
      
      <div class="buttons-container">
        <button :disabled="saving" class="btn btn-primary btn-lg btn-save"
                @click.prevent="saveBiosecurityQuestionnaire">
          <spinner v-if="saving" class="text-white" small></spinner>
          Guardar cuestionario
        </button>
      </div>
    </form>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import SectionOne from './questionnaires/biosecurity/SectionOne'
  import 'jquery-validation'
  import Spinner from '../ui/Spinner'
  import { AlertManager } from '../utils/AlertManager'
  import SectionTwo from './questionnaires/biosecurity/SectionTwo'
  import SectionThree from './questionnaires/biosecurity/SectionThree'
  import SectionFour from './questionnaires/biosecurity/SectionFour'
  import SectionFive from './questionnaires/biosecurity/SectionFive'
  
  export default {
    name: 'BiosecurityQuestionaire',
    components: {
      SectionFive,
      SectionFour,
      SectionThree,
      SectionTwo,
      SectionOne,
      Spinner,
    },
    props: {
      protocol: Object,
    },
    data: () => ({
      saving: false,
    }),
    methods: {
      ...mapActions({
        saveQuestionnaire: 'protocols/saveBiosecurityQuestionnaire',
      }),
      
      async saveBiosecurityQuestionnaire () {
        const $formBio = $('.biosecurity-form')
        
        if (!$formBio.valid()) {
          return
        }
        
        this.saving = true
        
        const formData = new FormData()
        
        // Set protocol id.
        formData.append('protocol_id', this.protocol.id)
        
        for (let data in this.questionnaire) {
          if (this.questionnaire.hasOwnProperty(data) && this.questionnaire[data] !== null) {
            if (Array.isArray(this.questionnaire[data])) {
              this.questionnaire[data].forEach((item, i) => {
                if (typeof item === 'object') {
                  for (let key in item) {
                    formData.append(data + '[' + i + ']' + '[' + key + ']', item[key])
                  }
                }
                else {
                  formData.append(data + '[]', item)
                }
              })
            }
            else {
              formData.append(data, this.questionnaire[data])
            }
          }
        }
        
        try {
          const response = await this.saveQuestionnaire(formData)
          
          const {
                  error,
                  message,
                  status,
                } = response.data.data
          
          if (status === 'error') {
            AlertManager.error(error)
            
            this.saving = false
            
            return Promise.reject(error)
          }
          
          AlertManager.success(message)
        } catch (e) {
          this.saving = false
        }
        
        this.saving = false
      },
      
      validateTabsInputs (form, tabs) {
        for (let tab of tabs) {
          const fields = this.$refs[tab].fields
          
          for (let q in fields) {
            if (this.questionnaire[q]) {
              fields[q].forEach(field => {
                
                if (this.questionnaire.hasOwnProperty(field)) {
                  form.find(`#${field}`).rules('add', {
                    required: true,
                    messages: {
                      required: 'Este campo es requerido',
                    },
                  })
                }
              })
            }
          }
        }
      },
    },
    computed: {
      ...mapGetters({
        questionnaire: 'protocols/biosecurityQuestionnaire',
      }),
    },
    mounted () {
      const vm       = this
      const $formBio = $('.biosecurity-form')
      
      $formBio.validate({
        ignore: [],
        highlight: function (element) {
          $(element).addClass('is-invalid')
        },
        unhighlight: function (element) {
          $(element).removeClass('is-invalid')
        },
        errorPlacement: function (error, element) {
          if (element.hasClass('select2-input')) {
            error.insertAfter(element.siblings('span.select2'))
          }
          else if (element.is(':radio')) {
            error.insertAfter($('[data-name=\'' + element.attr('name') + '\']'))
          }
          else {
            error.insertAfter(element)
          }
          
          error.addClass('invalid-feedback')
        },
        rules: {},
      })
      
      vm.validateTabsInputs($formBio, [
        'section-two',
        'section-three',
        'section-four',
        'section-five',
      ])
      
      /**
       * Fix file name change on validating inputs
       */
      $('.custom-file-input').on('change', function () {
        var fileName = $(this).val().split('\\').pop()
        $(this).nextAll('.custom-file-label').html(fileName)
      })
    },
  }
</script>
